import { ITheme, IPersonaStyles, IStyle, IImageStyles } from '@fluentui/react';

export const tooltipMaxWidth: number = 320;

export interface LastEditedStyles {
  persona?: Partial<IPersonaStyles>;
  personaButton?: IStyle;
  tooltipPersona?: Partial<IPersonaStyles>;
  personaCoinImage?: Partial<IImageStyles>;
}

export interface LastEditedStyleProps {
  theme?: ITheme;
}

export function getLastEditedDefaultStyle(props: LastEditedStyleProps): LastEditedStyles {
  const { theme } = props;

  const personaFontSize = `14px`;
  const personaFontFamily = `Segoe UI, sans-serif`;

  return {
    persona: {
      root: {
        flexDirection: 'row-reverse',
        display: 'inline-flex'
      },
      details: {
        paddingLeft: 0,
        paddingRight: 4
      },
      primaryText: {
        fontSize: personaFontSize,
        fontFamily: personaFontFamily,
        color: theme ? theme.palette.neutralSecondary : '#606060'
      }
    },
    personaButton: {
      paddingLeft: 8,
      paddingRight: 6,
      border: 'none',
      backgroundColor: 'transparent',
      borderRadius: 4,
      // The default button from the fluent-ui library has the height: 32px
      height: 32,
      cursor: 'pointer',
      [':hover']: {
        backgroundColor: theme ? theme.palette.neutralLighter : '#F3F2F1'
      },
      [':active']: {
        backgroundColor: theme ? theme.palette.neutralLight : '#EDEBE9'
      },
      // This is coming from fluent-ui.
      [':focus-visible']: {
        outline: 'rgb(96, 94, 92) solid 1px'
      }
    },
    tooltipPersona: {
      primaryText: {
        fontSize: personaFontSize,
        fontFamily: personaFontFamily,
        color: theme ? theme.palette.neutralPrimary : '#323232'
      }
    },
    personaCoinImage: {
      root: {
        marginRight: '10px',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        border: 0,
        borderRadius: '50%',
        perspective: '1px'
      }
    }
  };
}
